import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const SendPush = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 11V19C19 20.6569 17.6569 22 16 22H8C6.34315 22 5 20.6569 5 19V5C5 3.34315 6.34315 2 8 2H13.8027C13.2922 2.88252 13 3.90714 13 5C13 8.31371 15.6863 11 19 11Z"
      fill={getColor(color, isColorInherited)}
    />
    <circle cx="19" cy="5" r="4" fill={getColor(color, isColorInherited)} />
  </SvgIcon>
);
